import styled from 'styled-components';

export const StyledAvailabilityOption = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #B5B7C6;
  margin-bottom: 5px;

    div {
      display: inline-block;

      &.selected {
        font-weight: 600;
        color: #000000;
      }
    }
  }
`;

export const StyledDetailViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 25px;

  .option {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: #F3F3F6;
    border-radius: 12px;
    padding: 9px 7px 9px 18px;
    min-height: 42px;
    margin-bottom: 8px;

    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: -0.24px;

    color: #000000;

    &.filled {
      background: #FFFFFF;
      border: 1px solid #EDEDF3;
      box-sizing: border-box;
      box-shadow: 0px 1px 1px rgba(136, 138, 152, 0.25);
      border-radius: 12px;

      .details {
        font-weight: normal;
      }
    }
  }
`;

export const StyledNormalViewContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  width: 100%;

  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: -0.24px;

  color: #888A98;

  .column {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100px;

    img {
      width: 16px;
      height: 16px;
      margin-top: 21px;
    }

    .hours-interval {
      margin: 14px 0;
      border: 1px solid #EDEDF3;
      box-sizing: border-box;
      box-shadow: 0px 1px 1px rgba(136, 138, 152, 0.25);
      border-radius: 26px;
      width: 100%;
      padding: 4px 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .hour {
      border: 1px solid #E6E5EB;
      box-sizing: border-box;
      width: 100%;
      border-bottom: none;
      min-height: 40px;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      &.last {
        border-bottom: 1px solid #E6E5EB;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }

      &.first {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }

      &.selected {
        background: #0085FF;
        border-color: rgba(255, 255, 255, 0.25);
        color: #fff;
      }
    }

    .availability-day-skeleton {
    	border-radius: 0;
    }
  }
`;

export const StyledAvailabilityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledAvailabilityHeader = styled.div`
  display: flex;
  width: 100%;
  padding-top: 15px;
  margin: 25px 0;
  border-top: 1px solid #F4F4F9;
  
  span.date {
    font-size: 14px;
    font-weight: bold;
  }
  
  .arrow {
    cursor: pointer;
  }
`;

export const StyledAvailabilityList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 25px;
`;

type StyledAvailabilityRowProps = {
    type: string;
};

export const StyledAvailabilityRow = styled.div<StyledAvailabilityRowProps>`
  display: flex;
  align-items: center;
  font-size: 14px;
  width: 100%;
  border-radius: 16px;
  gap: 15px;
  padding: 16px 20px;
  height: 72px;
  cursor: pointer;
  transition: all 0.25s ease;
  position: relative;
  overflow: hidden;

  background: ${({ type }) =>
      type === 'proposal'
          ? 'linear-gradient(135deg, #0f9d58 0%, #34a853 35%, #66bb6a 100%)'
          : 'transparent'};

  border: ${({ type }) =>
      type === 'proposal'
          ? '1px solid rgba(52, 168, 83, 0.6)'
          : type === 'availability'
              ? '1px solid #34a853'
              : '1px solid #f0f0f5'};

  color: ${({ type }) =>
      type === 'proposal'
          ? '#fff'
          : type === 'availability'
              ? '#34a853'
              : '#1a1a1a'};

  box-shadow: ${({ type }) =>
      type === 'proposal'
          ? '0 4px 12px rgba(52, 168, 83, 0.25)'
          : '0 2px 6px rgba(0, 0, 0, 0.05)'};

  &:before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 16px;
    background: ${({ type }) =>
        type === 'proposal'
            ? 'linear-gradient(135deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.05) 100%)'
            : 'none'};
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover::before {
    opacity: 1;
  }
  
  ${({ type }) =>
      type === 'proposal' &&
      `
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(52, 168, 83, 0.35);
      }
    `}

  ${({ type }) =>
      type === 'availability' &&
      `
      &:hover {
        transform: translateY(-2px);
      }
    `}

  .time {
    font-size: 12px;
    opacity: 0.9;
  }

  .content {
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .info {
      display: flex;
      flex-direction: column;
      gap: 3px;
    }
  }
`;

export const StyledAvailabilityRowButton = styled.button`
  padding: 10px;
  border-radius: 5px;
  background-color: #eaebff;
  
  &:hover {
    opacity: 0.8;
  }
`;